// src/features/staff/pages/StaffDetailsPage/components/TabPanel.jsx

import React from 'react';
import { Box } from '@mui/material';

/** With `fill` the panel takes the rest of the page height (for file viewers) */
export default function TabPanel({ children, value, index, fill = false, ...other }) {
  const active = value === index;
  return (
    <div
      role="tabpanel"
      hidden={!active}
      id={`staff-tabpanel-${index}`}
      aria-labelledby={`staff-tab-${index}`}
      style={fill && active ? { flex: '1 0 auto', display: 'flex', flexDirection: 'column' } : undefined}
      {...other}
    >
      {active && (
        <Box sx={{ pt: 3, ...(fill && { flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' }) }}>
          {children}
        </Box>
      )}
    </div>
  );
}
